import { Workbox } from 'workbox-window';

export function registerServiceWorker(onNeedRefresh?: () => void) {
	if ('serviceWorker' in navigator) {
		const wb = new Workbox('/service-worker.js');

		wb.addEventListener('waiting', () => {
			// a new SW is waiting to activate
			onNeedRefresh && onNeedRefresh();
		});

		wb.addEventListener('externalwaiting' as any, () => {
			onNeedRefresh && onNeedRefresh();
		});

		wb.register();

		return wb;
	}
	return null;
}

export async function skipWaitingAndReload() {
	if (!('serviceWorker' in navigator)) return;
	const regs = await navigator.serviceWorker.getRegistrations();
	for (const reg of regs) {
		reg.waiting?.postMessage({ type: 'SKIP_WAITING' });
	}
	window.location.reload();
}
